module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-setup",
    class: _vm.$style.root
  }, [_c('b-modal', {
    ref: "campaignSetupModal",
    staticClass: "campaign-setup",
    attrs: {
      "size": "lg",
      "hide-header": true,
      "hide-footer": true,
      "no-close-on-esc": true,
      "no-close-on-backdrop": true
    },
    on: {
      "hide": function($event) {
        _vm.start()
      }
    }
  }, [(_vm.loading) ? _c('loading') : [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])] : [(_vm.visibleOptCount == 1) ? _c('div', [_c('h1', {
    staticClass: "welcome-title"
  }, [_vm._v(_vm._s(_vm.$t("pos.setup.title")))]), _c('p', {
    staticClass: "welcome-description"
  }, [_vm._v(_vm._s(_vm.$t("pos.setup.description")))])]) : _c('div', [_c('h1', {
    staticClass: "welcome-title"
  }, [_vm._v(_vm._s(_vm.$t("pos.setup.title_leads")))])]), (_vm.visibleOptCount > 1) ? _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 d-flex"
  }, [_c('div', {
    staticClass: "goal-type-container"
  }, _vm._l((_vm.goalOpts), function(goal, key) {
    return _c('div', {
      staticClass: "goal-type"
    }, [_c('div', {
      staticClass: "type",
      on: {
        "click": function($event) {
          _vm.updateGoalType(goal.key)
        }
      }
    }, [(goal.label_icon) ? _c('div', {
      staticClass: "icon"
    }, [_c('div', {
      staticClass: "box-icon",
      style: ({
        backgroundImage: ("url(" + (goal.label_icon) + ")")
      }),
      attrs: {
        "data-goal-type": goal.key
      }
    })]) : _vm._e(), _c('p', [_vm._v(_vm._s(goal.text))]), (_vm.displayNotificationFor === goal.key) ? _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.getGoalTypeNotice(goal.key))
      }
    }), _c('div', {
      staticClass: "options"
    }, [_c('b-button', {
      attrs: {
        "variant": "start",
        "size": "sm"
      }
    }, [_vm._v("OK")]), _c('b-button', {
      attrs: {
        "variant": "cancel",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.displayNotificationFor = null
        }
      }
    }, [_vm._v("CANCEL")])], 1)])]) : _vm._e()])])
  }))])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('b-button', {
    staticClass: "btn",
    attrs: {
      "variant": "start",
      "size": "lg"
    },
    on: {
      "click": function($event) {
        _vm.$refs.campaignSetupModal.hide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.setup.start')))])], 1)])]]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb7122a8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-setup/CampaignSetup.vue
// module id = 970
// module chunks = 1